import script from "./PurchaseRentSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseRentSearch.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseRentSearch.vue?vue&type=style&index=0&id=7143229a&lang=scss"

const __exports__ = script;

export default __exports__